<template>
  <!-- services -->
  <section class="section services">
    <div class="service-right">
      <img
        src="@/assets/img/bg/service-right.svg"
        class="img-fluid"
        alt="services right"
      />
    </div>
    <div class="container">
      <!-- Heading title-->
      <div class="section-heading" data-aos="fade-down">
        <h2 class="main-title">كيف يعمل</h2>
        <p class="main-description">
          حجز سيارة للإيجار هو عملية بسيطة تتضمن الخطوات التالية عادةً
        </p>
      </div>
      <!-- /Heading title -->
      <div class="services-work">
        <div class="row">
          <div
            class="col-lg-4 col-md-4 col-12 d-flex"
            v-for="item in IndexService"
            :key="item.id"
            data-aos="fade-down"
          >
            <div :class="item.ServiceClass">
              <div :class="item.IconClass">
                <img
                  :class="item.ImgClass"
                  :src="require(`@/assets/img/icons/${item.Image}`)"
                  alt="Choose Locations"
                />
              </div>
              <div class="services-content">
                <h3>{{ item.Title }}</h3>
                <p>
                  {{item.Content}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /services -->
</template>

<script>
import IndexService from "@/assets/json/index-service.json";
export default {
  data() {
    return {
      IndexService: IndexService,
    };
  },
};
</script>


<style scoped>
.services {
  padding: 80px 0;
  background-color: #f8f9fa;
  margin-top: 600px;
}

.main-title {
  color: green;
  font-size: 1.8rem;
  font-weight: 700;
}

.main-description {
  color: #6c757d;
  font-size: 1.1rem;
}

.service-description {
  color: #495057;
}

</style>
